export const FUNDING_TRIGGER_EVENT = 'FUNDING_TRIGGER_EVENT';
export const FUNDING_SEND_MESSAGE = 'FUNDING_SEND_MESSAGE';
export const FUNDING_UPDATE_CONVERSATION = 'FUNDING_UPDATE_CONVERSATION';
export const FUNDING_BOT_LOADING = 'FUNDING_BOT_LOADING';
export const FUNDING_REQUEST_FAILED = 'FUNDING_REQUEST_FAILED';
export const FUNDING_RESET_CONVERSATION = 'FUNDING_RESET_CONVERSATION';
export const FUNDING_UPDATE_USER_DATA = 'FUNDING_UPDATE_USER_DATA';
export const FUNDING_UPDATE_USER_CHOICE = 'FUNDING_UPDATE_USER_CHOICE';